import { initContract } from "@ts-rest/core";
import { dubPartnersPublicTokenResponseSchema } from "../schemas/dub-partners.schema";

const c = initContract();

export const dubPartnersContract = c.router(
    {
        getPublicToken: {
            method: "GET",
            path: "/public-token",
            responses: {
                200: dubPartnersPublicTokenResponseSchema,
            },
        },
    },
    {
        pathPrefix: "/dub-partners",
    },
);
